<template>
    <v-card class="fillParent" style="display: flex;">

      <div v-if="prop.type !== 'doc'" style="padding-top: 10px;margin:0 40px;">
          <v-autocomplete :label="listLabel" v-model="nodeType" @change="typeChanged()"
                         no-data-text="All types" :clearable="nodeType !== model.rdlName"
                        :items="types" item-text="txt" item-value="val">
          </v-autocomplete>
      </div>
    
      <v-data-table :headers="heads" :items="propVals" hide-default-footer class="elevation-1 propTbl fillParent tunedScrollBar"
                    :items-per-page=-1 fixed-header style="overflow: hidden;">
        <template v-slot:header.val_view="{ header }">
            {{ $t( 'message.full_custom_title', { cur_ttl: $t(`${header.text}`) } ) }}
        </template>
        <template v-slot:header.name="{ header }">
            {{ $t( 'message.full_custom_title', { cur_ttl: $t(`${header.text}`) } ) }}
        </template>
        <template v-slot:header.prnType="{ header }">
            {{ $t( 'message.full_custom_title', { cur_ttl: $t(`${header.text}`) } ) }}
        </template>
        <template v-slot:header.type="{ header }">
            {{ $t( 'message.full_custom_title', { cur_ttl: $t(`${header.text}`) } ) }}
        </template>
        <template v-slot:header.descr="{ header }">
            {{ $t( 'message.full_custom_title', { cur_ttl: $t(`${header.text}`) } ) }}
        </template>
        <template v-slot:header.role="{ header }">
            {{ $t( 'message.full_custom_title', { cur_ttl: $t(`${header.text}`) } ) }}
        </template>
        <template v-slot:header.subj="{ header }">
            {{ $t( 'message.full_custom_title', { cur_ttl: $t(`${header.text}`) } ) }}
        </template>
        <template v-slot:header.act="{ header }">
            <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click="addProp()">add</v-icon>
                </template>
                <span>{{ $t( 'message.prop_add_btn' ) }}</span>
            </v-tooltip> -->
        </template>
        
        <template v-slot:item="{ item }">
            <tr draggable @dragstart="startDrag( $event, item )" @drop="onDrop($event, item)" 
                @dragover.prevent @dragenter.prevent>
                  <td>
                        <v-tooltip bottom>
                            <template v-slot:activator="{on, attrs}">
                                <span v-bind="attrs" v-on="on" :class="{ mandatory_field: item.isMandatory }">{{ item.val_view }}</span>
                            </template>
                            <span>{{ item.obj.property_urn }}</span> 
                        </v-tooltip>
                        <div>
                            <span v-if="item.isHidden" class="tags">Hidden</span>
                            <span v-if="item.isExclusive" class="tags">Exclusive</span>
                        </div>
                  </td>
                  <td>
                        <v-tooltip bottom>
                            <template v-slot:activator="{on, attrs}">
                            <span v-bind="attrs" v-on="on">{{ item.prnType }}</span>
                            </template>
                            <span>{{ item.obj.assigned_to }}</span> 
                        </v-tooltip>
                  </td>
                  <td>
                        <v-tooltip bottom>
                            <template v-slot:activator="{on, attrs}">
                            <span v-bind="attrs" v-on="on">{{ item.type }}</span>
                            </template>
                            <span>{{ item.obj.assignment_type }}</span> 
                        </v-tooltip>
                  </td>
                  <td>{{ item.descr }}</td>
                  <td>
                        <v-tooltip bottom>
                            <template v-slot:activator="{on, attrs}">
                            <span v-bind="attrs" v-on="on">{{ item.role }}</span>
                            </template>
                            <span>{{ item.obj.role_urn }}</span> 
                        </v-tooltip>
                  </td>
                  <td>{{ item.subj }}</td>
                  <td style="white-space: nowrap;">
                      <v-tooltip bottom v-if="!item.readOnly">
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" small class="mr-2" @click="editPropItem( item )">edit</v-icon>
                            </template>
                            <span>{{ $t( 'message.prop_editP_btn' ) }}</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="item.canDel">
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" small class="mr-2" @click="deleteItem( item )">delete</v-icon>
                            </template>
                            <span>{{ $t( 'message.prop_deleteP_btn' ) }}</span>
                      </v-tooltip>
                      <!-- <v-tooltip bottom v-if="prop.rdlName === 'urn:rdl:epm-std:breakdown_element_type'">
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" @click="addNotify( item )" small>notifications</v-icon>
                            </template>
                            <span>{{ $t( 'message.prop_notify_btn' ) }}</span>
                      </v-tooltip> -->
                  </td>
            </tr>
        </template>
      </v-data-table>
    </v-card>
</template>

<script>
import{ conf } from '@/utils/confTruePLM';

export default {
  name: 'PropInfoNodeSys',
  props: {
      prop: null
  },
  data () {
    return {
        heads: [
            { text: 'message.prop_name_col', value: 'val_view' }, 
            { text: 'message.prop_prn_col', value: 'prnType' }, 
            { text: 'message.prop_type_col', value: 'type' }, 
            { text: 'message.prop_descr_col', value: 'descr' }, 
            { text: 'message.prop_role_col', value: 'role' }, 
            { text: 'message.prop_subj_col', value: 'subj' }, 
            { width: '15%', sortable: false, value: 'act' }
        ],
        propVals : [],
        propList: [],
        model: this.prop,
        nodeType: null,
        types: [],
        listTypes: [],
        typeRoleMap: {},
        // orderBy: 'name',
        // orderByFin: 'name',
        // orderFlds: []
    };
  },
  watch: {
      prop() 
      {
        // console.log( this.prop );
          this.nodeType = null;
          this.updateModel();
      }
  },
  computed:
  {
    //   isForNode()
    //   {
    //       return this.prop.rdlName === 'urn:rdl:epm-std:breakdown_element_type';
    //   },
      listLabel()
      {
         if( this.prop.rdlName === 'urn:plcs:rdl:TruePLM:ComplexDataType' )
              return this.$t( 'message.node_prop_sel_struct' );
          else if( this.prop.rdlName === 'urn:plcs:rdl:TruePLM:Requirement' )
              return this.$t( 'message.node_prop_sel_req' );
          else if( this.prop.rdlName === 'urn:rdl:epm-std:Document_content_type' )
              return this.$t( 'message.node_prop_sel_doc' );
          else if( this.prop.rdlName === 'urn:rdl:epm-std:Part_type' )
              return this.$t( 'message.node_prop_sel_prod' );
          else if( this.prop.rdlName === 'urn:plcs:rdl:TruePLM:System_event' )
              return this.$t( 'message.node_prop_sel_event' );
          else
              return this.$t( 'message.node_prop_sel' );
      },
  },
  methods: 
  {
      startDrag( evt, item ) 
      {
          evt.dataTransfer.dropEffect = 'move';
          evt.dataTransfer.effectAllowed = 'move';
          localStorage.setItem( 'dragID', '' + item.num );
      },
      onDrop( evt, item ) 
      {
          let dragID = localStorage.getItem( 'dragID' );
          localStorage.removeItem( 'dragID' );

          let elem = this.propVals[ dragID ];
          this.propVals.splice( dragID, 1 );
          this.propVals.splice( item.num, 0, elem );
          
          let orderStr = '';
          this.propVals.forEach( p => 
          {
              if( orderStr === '' )
                  orderStr = p.obj.property_urn;
              else
                  orderStr += ',' + p.obj.property_urn;
          });

          let self = this;
          conf.setAssignmentOrder( self.nodeType, orderStr )
                  .then( () => 
          {
               self.updateModel( self.model, self.nodeType );  
          } )
                  .catch( ( err ) =>
          {
              self.$eventBus.$emit( 'queryError', err );
          });
      },
    //   addProp()
    //   {
    //       let self = this;
    //       let lists = this.isForNode ? this.listTypes : null;          
    //       this.$modalDlg.sysDlgs.createPropDlg.open( null, lists, this.isForNode )
    //               .then( ( prop ) =>
    //       {
    //           self.addPropWithCheck( prop );
    //       }, () => {} );
    //   },
    //   addPropWithCheck( prop )
    //   {
    //       let self = this;
    //       conf.getPropInfo( prop.name )
    //             .then( info =>
    //       {
    //           if( this.$utils.clearType( info.urn ) === prop.name 
    //                   && this.$utils.clearType( info.domain ) !== prop.type )
    //               self.addPropWarning( info, prop );
    //           else
    //               self.addPropNow( prop );
    //       })
    //             .catch( ( err ) =>
    //       {
    //           self.addPropNow( prop );
    //       });
    //   },
    //   addPropWarning( info, prop )
    //   {
    //       let self = this;
    //       if( info.inUse )
    //           this.$modalDlg.sysDlgs.confirmDlg.openError( 'error_ttl', 'error_prop_exist_used_msg' );
    //       else
    //       {
    //           this.$modalDlg.sysDlgs.confirmDlg.openWarning( 'warning_ttl', 'warning_prop_exist_msg' )
    //                   .then( () =>
    //           {
    //               self.addPropNow( prop );
    //           }, () => {} );
    //       }
    //   },
    //   addPropNow( prop )
    //   {
    //       let self = this;
    //       conf.addRefDataProp( prop, self.nodeType )
    //               .then( () => 
    //       {
    //            self.updateModel( self.model, self.nodeType );  
    //       } )
    //               .catch( ( err ) =>
    //       {
    //           self.$eventBus.$emit( 'queryError', err );
    //       });
    //   },
      editPropItem( inProp )
      {
          let self = this;       
          this.$modalDlg.sysDlgs.createSysPropDlg.open( inProp.obj, this.model.rdlName, this.typeRoleMap )
                  .then( ( prop ) =>
          {
              console.log( prop );
              if( !inProp.canDel && inProp.isHidden !== prop.hidden )
                    return conf.setHiddenAssignment( inProp.obj, prop.hidden );
              else
                return Promise.resolve( prop );
          }, () => {} )
                  .then( () => 
          {
               self.updateModel( self.model, self.nodeType );  
          })
                  .catch( ( err ) =>
          {
              self.$eventBus.$emit( 'queryError', err );
          });
      },
      deleteItem( prop )
      {
          let self = this;
          let msg = 'nodeprop_delete_msg';
          if( prop.obj && prop.obj.inUse )
              msg = 'nodeprop_used_delete_msg';
          let ttl = 'nodeprop_delete_title';
          if( this.prop.rdlName === 'urn:rdl:epm-std:Document_content_type' )
              ttl = 'docprop_delete_title'
          this.$modalDlg.sysDlgs.confirmDlg.open( ttl, msg )
                  .then( () =>
          {
              return conf.deleteRefData( prop.obj.urn, self.nodeType );
          }, () => {} )
                .then( () =>
          {
              return conf.deletePropVals( prop.obj.urn, self.nodeType );
          }, () => {} )
                  .then( () =>
          {
              self.updateModel( self.model, self.nodeType );              
          })
                  .catch( ( err ) =>
          {
              self.$eventBus.$emit( 'queryError', err );
          });          
      },
      
      fillSubtypes( map, rInfo )
      {
          if( !rInfo )
            return;
          rInfo.forEach( el =>
          {
                map[ el.urn ] = el.name;
                this.fillSubtypes( map, el.subtypes );   
          } );
      },

      typeChanged()
      {
          let self = this;
          self.propVals = [];
          
          this.orderBy = null;
          this.orderByFin = null;
          this.orderFlds = [ { txt: 'Name', val: 'urn:plcs:rdl:std:Name' } ];
          
          self.$modalDlg.sysDlgs.progressDlg.open();
          
          if( !self.nodeType )
              self.nodeType = self.model.rdlName
         
          let tmpValList = [];
          Promise.all( [ conf.listAssignmentConcepts( self.nodeType ), conf.listAssignmentTypes() ] )
                  .then( info =>
          {
              let data = info[ 0 ];
              if( !data || !data.length )
              {
                  self.$modalDlg.sysDlgs.progressDlg.close();
                  return;
              }

              self.typeRoleMap = {};
              info[ 1 ].forEach( el => 
              {
                  self.typeRoleMap[ el.urn ] = el.name;
                  self.typeRoleMap[ el.roles_branch.urn ] = el.roles_branch.name;
                  self.fillSubtypes( self.typeRoleMap, el.roles_branch.subtypes );
              });

              let ind = 0;
              const curUrn = 'urn:rdl:' + conf.getProjModel() + ':';
              data.forEach( ( elem ) =>
              {
                  let prnType = '';
                  if( elem.assigned_to !== this.nodeType )
                  {
                      prnType = self.$utils.clearType( elem.assigned_to );
                      if( 'breakdown_element_type' === prnType )
                          prnType = 'Breakdown element';
                  }
                  
                  let canDel = ( self.nodeType === elem.assigned_to ) 
                          && !elem.property_urn.startsWith( 'urn:plcs:rdl:std:' )
                          && !elem.property_urn.startsWith( 'urn:plcs:rdl:TruePLM:' )
                          && !elem.property_urn.startsWith( 'urn:rdl:epm-std:' );

                  let readOnly = ( self.nodeType !== elem.assigned_to );
                  
                  let name = elem.name;
                  tmpValList.push( { num: ind++, obj: elem, val_view: name, 
                      type: self.typeRoleMap[ elem.assignment_type ] || self.$utils.clearType( elem.assignment_type ), 
                      role: self.typeRoleMap[ elem.role_urn ] || self.$utils.clearType( elem.role_urn ), 
                      subj: elem.subject, 
                      isHidden: elem.tags.includes( 'HIDDEN' ), isExclusive: elem.tags.includes( 'EXCLUSIVE' ),
                      isMandatory: !elem.tags.includes( 'OPTIONAL' ), prnType: prnType, descr: elem.description, readOnly: 
                      readOnly, canDel: canDel } );   
              });

              self.propVals = tmpValList;
              
              self.$modalDlg.sysDlgs.progressDlg.close();
          })
                .catch( ( err ) =>
          {
              self.$modalDlg.sysDlgs.progressDlg.close();
              this.$eventBus.$emit( 'queryError', err );
          });
      },
      updateModel( nodeType )
      {
          this.propVals = [];
          this.model = this.prop;
          this.types = [ { val: this.model.rdlName, txt: 'All types' } ];
          this.nodeType = this.nodeType || nodeType || this.model.rdlName;
          let self = this;
          
          self.$modalDlg.sysDlgs.progressDlg.open();
          
          conf.getChildTypesInContext( this.model.rdlName )
                  .then( ( data ) =>
          {
              this.$utils.sortArray( data, ( a ) => ( this.$utils.clearType( a ) ) );
              data.forEach( ( val ) =>
              {
                  self.types.push( { val: val, txt: this.$utils.clearType( val ) } );     
              });

              self.typeChanged();
          })
                  .catch( ( err ) =>
          {
              self.$modalDlg.sysDlgs.progressDlg.close();
              self.$eventBus.$emit( 'queryError', err );
          });                   
      }
  },
  mounted: function() 
  { 
      this.updateModel();
  },   
  beforeDestroy: function()
  {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .propTbl td
    {
        height: 30px;
    }        
    .tags
    {
        font-size: small;
        font-style: italic;
        padding-right: 5px;
    }
</style>
